"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/kyc-error.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fkyc-error.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.kycErrorToJSON = exports.kycErrorFromJSON = exports.KycError = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
var KycError;
(function (KycError) {
    KycError["INVALID_ERROR"] = "INVALID_ERROR";
    KycError["SSN_INVALID"] = "SSN_INVALID";
    KycError["DOB_INVALID"] = "DOB_INVALID";
    KycError["NAME_INVALID"] = "NAME_INVALID";
    KycError["ADDRESS_INVALID"] = "ADDRESS_INVALID";
    /**
     * THIN_FILE - "Thin File" KYC error when we believe that the user
     * did not establish their credit history yet:
     * - user is 18-22 and
     * - their DOB is not verified and
     * - no fraud attributes
     */
    KycError["THIN_FILE"] = "THIN_FILE";
    KycError["DUPLICATE_SSN"] = "DUPLICATE_SSN";
    KycError["SARDINE_FRAUD"] = "SARDINE_FRAUD";
    KycError["RISK"] = "RISK";
    KycError["UNRECOGNIZED"] = "UNRECOGNIZED";
})(KycError || (exports.KycError = KycError = {}));
function kycErrorFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ERROR':
            return KycError.INVALID_ERROR;
        case 1:
        case 'SSN_INVALID':
            return KycError.SSN_INVALID;
        case 2:
        case 'DOB_INVALID':
            return KycError.DOB_INVALID;
        case 3:
        case 'NAME_INVALID':
            return KycError.NAME_INVALID;
        case 4:
        case 'ADDRESS_INVALID':
            return KycError.ADDRESS_INVALID;
        case 5:
        case 'THIN_FILE':
            return KycError.THIN_FILE;
        case 6:
        case 'DUPLICATE_SSN':
            return KycError.DUPLICATE_SSN;
        case 7:
        case 'SARDINE_FRAUD':
            return KycError.SARDINE_FRAUD;
        case 8:
        case 'RISK':
            return KycError.RISK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return KycError.UNRECOGNIZED;
    }
}
exports.kycErrorFromJSON = kycErrorFromJSON;
function kycErrorToJSON(object) {
    switch (object) {
        case KycError.INVALID_ERROR:
            return 'INVALID_ERROR';
        case KycError.SSN_INVALID:
            return 'SSN_INVALID';
        case KycError.DOB_INVALID:
            return 'DOB_INVALID';
        case KycError.NAME_INVALID:
            return 'NAME_INVALID';
        case KycError.ADDRESS_INVALID:
            return 'ADDRESS_INVALID';
        case KycError.THIN_FILE:
            return 'THIN_FILE';
        case KycError.DUPLICATE_SSN:
            return 'DUPLICATE_SSN';
        case KycError.SARDINE_FRAUD:
            return 'SARDINE_FRAUD';
        case KycError.RISK:
            return 'RISK';
        case KycError.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.kycErrorToJSON = kycErrorToJSON;
//# sourceMappingURL=kyc-error.js.map